import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { isNullUndefined, isNullUndefinedOrEmpty } from "../../common/Helpers";
import { Col, Row } from "react-bootstrap";
import { Icon, IconButton } from "@fluentui/react";
import { __NotificationClass, __NotificationTypesMenuTitles, enum__NOTIFICATION_CLASS, enum__NOTIFICATION_TYPE } from "../../common/Dictionaries";
import moment from "moment";
import { useSelector } from "react-redux";
import AchieveValidateNotificationDialog from "./SidePanels/AchieveValidate/AchieveValidateNotificationDialog";

const NotificationTasksCard = (props) => {
    const { t } = useTranslation();

    const { 
        inputParam_ObjItem = null,
        inputParam_ShowMinimized = false,
        inputParam_HandlerOnClickNotificationTaskRow = null,
        inputParam_FieldActionHandler = null,
    } = props;

    const { 
        _notificationTaskDataList: notificationTaskDataList,
        _notificationTaskDataListFiltred: notificationTaskDataListFiltred,
        _notificationTaskMenuData: notificationTaskMenuData
    } = useSelector((state) => state.notificationTaskState);
    
    const [normalizedNotificationClass] = useState(__NotificationClass.find(x => x.key === inputParam_ObjItem.notificationClassId));
    const [isWarningModalActionDialogOpen, setIsWarningModalActionDialogOpen] = useState(false);
    const [notificationTaskActionToWarningDialog, setNotificationTaskActionToWarningDialog] = useState(null);

    const getPriorityColor = (priority) => {
		switch (priority) {
			case 1: return "red"   ; break;
			case 2: return "orange"; break;
			case 3: return "yellow"; break;
			case 4: return "green" ; break;
			default: return "blue" ; break;
		}
	};

    
    const handleOnOpenWargingDialog = (action) => {
        setNotificationTaskActionToWarningDialog(action)
        setIsWarningModalActionDialogOpen(true)
    }

    const handleOnCompleteReject = (action) => {
        inputParam_FieldActionHandler && inputParam_FieldActionHandler(inputParam_ObjItem.id, action, null, notificationTaskDataList, notificationTaskDataListFiltred)
    }

    const getPriorityData = (value) => {
        const prioridadReal = value % 10; 
        
        const tipoIcono = Math.floor(value / 100);

        return {
            originalPriority: prioridadReal,
            auxiliarPriority: tipoIcono || null
        };
    };

    const aux_priority = getPriorityData(inputParam_ObjItem.priority);

    return (<Row style={{marginLeft: "0px", borderLeft: `5px solid ${getPriorityColor(aux_priority.originalPriority)}`}}>
                {
                    (!inputParam_ShowMinimized) &&
                    <Col className="col-auto ms-auto my-auto p-0">
                        <IconButton
                            iconProps={{ iconName: 'EntryView' }}
                            title={inputParam_ObjItem.notificationClassId === enum__NOTIFICATION_CLASS.CO_TO_ACHIEVE ? t('data-lang-btn-detailedachiement') : (inputParam_ObjItem.notificationClassId === enum__NOTIFICATION_CLASS.CO_TO_VALIDATE ? t('data-lang-btn-detailedvalidation') : t('data-lang-btn-view')) }
                            ariaLabel={inputParam_ObjItem.notificationClassId === enum__NOTIFICATION_CLASS.CO_TO_ACHIEVE ? t('data-lang-btn-detailedachiement') : (inputParam_ObjItem.notificationClassId === enum__NOTIFICATION_CLASS.CO_TO_VALIDATE ? t('data-lang-btn-detailedvalidation') : t('data-lang-btn-view')) }
                            onClick={() => inputParam_FieldActionHandler(inputParam_ObjItem.id, 'view', null, notificationTaskDataList, notificationTaskDataListFiltred)}
                        />
                    </Col>
                }
                {
                    !inputParam_ShowMinimized && inputParam_ObjItem.needPanel === false && inputParam_ObjItem.notificationTypeId !== enum__NOTIFICATION_TYPE.ANNOUNCEMENT &&
                    <Col className="col-auto ms-auto my-auto p-0 width-65px">
                        {
                            (inputParam_ObjItem.notificationClassId === enum__NOTIFICATION_CLASS.BOOK_MSG_VISA ? false : (inputParam_ObjItem.canAchieve && (isNullUndefinedOrEmpty(inputParam_ObjItem.completed))))  &&
                            <>
                                <IconButton iconProps={{ iconName: 'StatusCircleCheckmark' }} title={t('data-lang-btn-complete')} ariaLabel={t('data-lang-btn-complete')} onClick={() => handleOnOpenWargingDialog('complete')} />
                                {
                                    (inputParam_ObjItem.notificationTypeId === enum__NOTIFICATION_TYPE.TASK || inputParam_ObjItem.notificationTypeId === enum__NOTIFICATION_TYPE.TASK_ROLE) &&
                                    <IconButton iconProps={{ iconName: 'StatusCircleErrorX' }} title={t('data-lang-btn-reject')} ariaLabel={t('data-lang-btn-reject')} onClick={() => handleOnOpenWargingDialog('reject')} />
                                }
                            </>
                        }
                    </Col>
                }
                <Col className="col-auto ms-auto my-auto">
                {
                    (inputParam_ObjItem.notificationTypeId === enum__NOTIFICATION_TYPE.ANNOUNCEMENT || inputParam_ObjItem.notificationTypeId === enum__NOTIFICATION_TYPE.ANNOUNCEMENT_ROLE) &&
                    <Icon iconName="Ringer" title={t('data-lang-lbl-announcement')} />
                }
                {
                    (inputParam_ObjItem.notificationTypeId === enum__NOTIFICATION_TYPE.TASK || inputParam_ObjItem.notificationTypeId === enum__NOTIFICATION_TYPE.TASK_ROLE) &&
                    <Icon iconName="Flag" title={t('data-lang-lbl-task')} />
                }
                </Col>
                <Col className='my-auto'>
                    <Row>
                        { inputParam_ObjItem.title }
                    </Row>
                    <Row>
                        <Col className='col-auto ms-auto border rounded bg-green my-auto mx-1' style={{fontSize: "10px"}}> { !isNullUndefined(normalizedNotificationClass) ? t(normalizedNotificationClass.text) : inputParam_ObjItem.notificationClass } </Col>
                        <Col className='col-auto ms-auto border rounded bg-green cursor-pointer my-auto mx-1' style={{color: "white", fontSize: "10px", backgroundColor: `${inputParam_ObjItem.completed === true ? "green" : "red"}`}}> { (inputParam_ObjItem.completed === true ? t('data-lang-lbl-completed') : t('data-lang-lbl-notcompleted')) } </Col>
                        <Col></Col>
                    </Row>
                </Col>
                <Col className="col-auto me-auto d-flex my-auto">
                    {
                        (inputParam_ObjItem.notificationTypeId === enum__NOTIFICATION_TYPE.TASK || inputParam_ObjItem.notificationTypeId === enum__NOTIFICATION_TYPE.TASK_ROLE) && (moment(inputParam_ObjItem.expirationDate).toDate() < moment(inputParam_ObjItem.completedDate).toDate()) &&
                        <Icon style={{fontSize: "21px"}} className="my-auto mx-1 px-1" iconName={'RemoveEvent'} text={t('data-lang-lbl-expired')} title={t('data-lang-lbl-expired')} aria-label={t('data-lang-lbl-expired')} />
                    }
                    {
                        inputParam_ObjItem.important === true &&
                        <Icon style={{fontSize: "21px", color: "red"}} className="mx-1 px-1 my-auto" iconName={'AlertSolid'} text={t('data-lang-lbl-important')} title={t('data-lang-lbl-important')} aria-label={t('data-lang-lbl-important')} />
                    }
                    {
                        !isNullUndefined(aux_priority.auxiliarPriority) &&
                        <Row className="d-flex align-items-center rounded-pill overflow-hidden mx-2" style={{ width: "fit-content" }}>
                            <Col className="d-flex align-items-center justify-content-center" style={{ fontWeight: "bolder", width: 32, height: 26 }}>
                                <Icon style={{fontSize: "21px"}} className="cursor-pointer my-1 mx-1 px-1" iconName={'ReportWarning'} text={t('data-lang-lbl-preventadnapproval-long2')}   title={t('data-lang-lbl-preventadnapproval-long2')}   aria-label={t('data-lang-lbl-preventadnapproval-long2')} />
                            </Col>
                        </Row>
                    }
                    {
                        (inputParam_ObjItem.notificationTypeId === enum__NOTIFICATION_TYPE.TASK || inputParam_ObjItem.notificationTypeId === enum__NOTIFICATION_TYPE.TASK_ROLE) &&
                        <Row className="d-flex align-items-center rounded-pill overflow-hidden mx-2" style={{ width: "fit-content" }}>
                            {
                                inputParam_ObjItem.completed === true &&
                                <Col className="bg-primary text-white d-flex align-items-center justify-content-center" style={{ fontWeight: "bolder", width: 32, height: 26 }}>
                                    <Icon
                                        iconName="CheckMark"
                                        text={t('data-lang-lbl-completed')}
                                        title={t('data-lang-lbl-completed')}
                                        aria-label={t('data-lang-lbl-completed')} 
                                    />
                                </Col>
                            }
                        </Row>
                    }
                    <Row>
                        <Col>
                            <Row>
                                <Col>
                                    {t('data-lang-lbl-assigneddate-short')}
                                </Col>
                                <Col className="col-auto ms-auto">
                                    <div className="my-auto px-1" title={(inputParam_ObjItem.notificationTypeId === enum__NOTIFICATION_TYPE.TASK || inputParam_ObjItem.notificationTypeId === enum__NOTIFICATION_TYPE.TASK_ROLE) ? t('data-lang-lbl-assigneddate') : t('data-lang-lbl-creationdate')}>{moment(inputParam_ObjItem.assignedDate).format('DD/MM/YYYY')}</div>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    {t('data-lang-lbl-expirationdate-short')}
                                </Col>
                                <Col className="col-auto ms-auto">
                                    <div className="my-auto px-1" title={(inputParam_ObjItem.notificationTypeId === enum__NOTIFICATION_TYPE.TASK || inputParam_ObjItem.notificationTypeId === enum__NOTIFICATION_TYPE.TASK_ROLE) ? t('data-lang-lbl-expirationdate') : t('data-lang-lbl-expirationdate')}>{!isNullUndefinedOrEmpty(inputParam_ObjItem.expirationDate) ? moment(inputParam_ObjItem.expirationDate).format('DD/MM/YYYY') : t('data-lang-lbl-nodata')}</div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    {
                        !inputParam_ShowMinimized &&
                        <IconButton 
                            className="my-auto px-1"
                            style={{fontSize: "25px"}}
                            iconProps={{ iconName: inputParam_ObjItem.expanded === true ? "Blocked2" : "AddTo" }}
                            onClick={!inputParam_ShowMinimized ? (() => inputParam_HandlerOnClickNotificationTaskRow(inputParam_ObjItem.id, notificationTaskDataList, notificationTaskDataListFiltred, notificationTaskMenuData)) : undefined}
                        />
                    }
                </Col>
                <AchieveValidateNotificationDialog
                    inputParam_IsModalOpen={isWarningModalActionDialogOpen}
                    inputParam_NotificationTask={inputParam_ObjItem}
                    inputParam_NotificationClassId={inputParam_ObjItem.notificationClassId}
                    inputParam_IsApprove={notificationTaskActionToWarningDialog === 'complete'}
                    inputParam_SetterIsModalOpen={setIsWarningModalActionDialogOpen}
                    inputParam_HandleAction={handleOnCompleteReject}
                />
            </Row>
  );
};

export default NotificationTasksCard;